import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const checkboxIconComponent = {
  root: 'checkbox-icon.root',
} as const satisfies ComponentLocatorMap;
